import { MutationTree } from 'vuex';
import { RoutineWorkTemplateState, RoutineWorkTemplate } from './types';
import * as types from './mutation-types';

// エラーをクリアする
const resetErrors = (state: RoutineWorkTemplateState): void => {
    const indexState = state.index;
    indexState.error = false;
    indexState.errorCode = undefined;
    indexState.errorMsg = undefined;
};

export const mutations: MutationTree<RoutineWorkTemplateState> = {
    // 申請テンプレート一覧系
    [types.INDEX_START](state) {
        resetErrors(state);
        const indexState = state.index;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },

    [types.INDEX_SUCCESS](state, payload: { count: number; templates: Array<RoutineWorkTemplate> }) {
        state.templateCount = payload.count;
        state.templates = payload.templates;

        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = true;
    },

    [types.INDEX_FAILURE](state, payload: { code: string; message: string }) {
        const indexState = state.index;
        indexState.errorCode = payload.code;
        indexState.errorMsg = payload.message;
        indexState.error = true;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.templates = undefined;
        state.templateCount = 0;
    },
};
